// monitoring Table components
import AudienceLabel from '@/components/monitoring/AudienceLabel'
import ExpandIcon from '@/components/monitoring/ExpandIcon'
import SharedIcon from '@/components/monitoring/SharedIcon'
import CellVolume from '@/components/monitoring/CellVolume'
import CellNamespaceAction from '@/components/settings/CellNamespaceAction'
import CellCheck from '@/components/settings/CellCheck'
import CellConfigAction from '@/components/onBoarding/CellConfigAction'

// cclone Table components
import TableVolumes from '@/components/common/TableVolumes'

// cclone && DEM Table components
import Status from '@/components/common/Status'

const BUILDER_CRITERIA_LIMITS = 255

const SOCIO_DEMO_CATEGORIES = [
    {
        label: 'Age',
        id: 'sociodemo_age',
        display_order: 1,
        hasChild: true,
        isSelectable: false,
        parentJsonKeyName: null,
        jsonKey: {
            ids: ['sociodemo_age'],
            name: 'sociodemo_sociodemo_age',
            type: 'Sociodemo',
            subType: 'age'
        }
    },
    {
        label: 'Education',
        id: 'sociodemo_education',
        display_order: 2,
        hasChild: true,
        isSelectable: false,
        parentJsonKeyName: null,
        jsonKey: {
            ids: ['sociodemo_education'],
            name: 'sociodemo_sociodemo_education',
            type: 'Sociodemo',
            subType: 'education'
        }
    },
    {
        label: 'Gender',
        id: 'sociodemo_gender',
        display_order: 3,
        hasChild: true,
        isSelectable: false,
        parentJsonKeyName: null,
        jsonKey: {
            ids: ['sociodemo_gender'],
            name: 'sociodemo_sociodemo_gender',
            type: 'Sociodemo',
            subType: 'gender'
        }
    },
    {
        label: 'Income',
        id: 'sociodemo_income',
        display_order: 4,
        hasChild: true,
        isSelectable: false,
        parentJsonKeyName: null,
        jsonKey: {
            ids: ['sociodemo_income'],
            name: 'sociodemo_sociodemo_income',
            type: 'Sociodemo',
            subType: 'income'
        }
    }
]

const MEDIA_CATEGORIES = [
    {
        label: 'Campaigns',
        id: 'campaign',
        display_order: 1,
        hasChild: true,
        isSelectable: false,
        parentJsonKeyName: null,
        jsonKey: {
            ids: ['campaign'],
            name: 'media_campaign',
            type: 'Campaign',
            subType: 'campaign'
        }
    },
    {
        label: 'Conversions',
        id: 'conversion',
        display_order: 2,
        hasChild: true,
        isSelectable: false,
        parentJsonKeyName: null,
        jsonKey: {
            ids: ['conversion'],
            name: 'media_conversion',
            type: 'Conversion',
            subType: 'conversion'
        }
    }
]

const TECHNO_CATEGORIES = {
    browser: [
        {
            label: 'Browsers',
            id: 'browser',
            hasChild: true,
            isSelectable: false,
            parentJsonKeyName: null,
            jsonKey: {
                ids: ['browser'],
                name: 'techno_browser',
                type: 'Techno',
                subType: 'browser'
            }
        }
    ],
    device: [
        {
            label: 'Devices',
            id: 'device',
            hasChild: true,
            isSelectable: false,
            parentJsonKeyName: null,
            jsonKey: {
                ids: ['device'],
                name: 'techno_device',
                type: 'Techno',
                subType: 'device'
            }
        }
    ],
    os: [
        {
            label: 'Operating Systems',
            id: 'os',
            hasChild: true,
            isSelectable: false,
            parentJsonKeyName: null,
            jsonKey: {
                ids: ['os'],
                name: 'techno_os',
                type: 'Techno',
                subType: 'os'
            }
        }
    ],
    isp: [
        {
            label: 'Internet Service Providers',
            id: 'isp',
            hasChild: true,
            isSelectable: false,
            parentJsonKeyName: null,
            jsonKey: {
                ids: ['isp'],
                name: 'techno_isp',
                type: 'Techno',
                subType: 'isp'
            }
        }
    ]
}

const VOLUMES = [
    {
        label: 'ID Based',
        options: [
            {
                label: 'Cookie',
                value: 'desktop',
                transferValue: 'Desktop identifier'
            },
            {
                label: 'Mobile',
                value: 'mobile',
                transferValue: 'Mobile identifier'
            },
            {
                label: 'First-id',
                value: 'firstid',
                transferValue: 'First-ID identifier',
                altId: 'first-id',
                visible: (partner) => ['appnexus', 'gam'].includes(partner),
            },
        ]
    },
    {
        label: 'Cross Device',
        options: [
            {
                label: 'Web',
                value: 'web',
                transferValue: 'User desktops'
            },
            {
                label: 'Apps',
                value: 'apps',
                transferValue: 'User mobiles'
            },
            {
                label: 'User',
                value: 'user',
                transferValue: 'User all devices'
            },
            {
                label: 'First-id user',
                value: 'firstid-user',
                transferValue: 'User First-ID',
                altId: 'first-id',
                visible: (partner) => ['appnexus', 'gam'].includes(partner),
            }
        ]
    }
]

const UTIQ_VOLUMES = [
    {
        label: 'ID Based',
        options: [

            {
                label :'Utiq mobile ',
                value :'Utiq mobile identifier',
                transferValue :'Utiq mobile identifier',
                altId: 'utiq',
            },

            {
                label :'Utiq home',
                value :'Utiq home identifier',
                transferValue :'Utiq home identifier',
                altId: 'utiq',
            },

            {
                label :'Utiq mobile & home',
                value :'Utiq all identifiers',
                transferValue :'Utiq all identifiers',
                altId: 'utiq',
            }
        ]
    },
    {
        label: 'Cross Device',
        options: [
            {
                label :'Utiq mobile user ',
                value :'User Utiq mobile',
                transferValue :'User Utiq mobile',
                altId: 'utiq'
            },

            {
                label :'Utiq home user',
                value :'User Utiq home',
                transferValue :'User Utiq home',
                altId: 'utiq'
            },

            {
                label :'Utiq mobile & home user ',
                value :'User all Utiq',
                transferValue :'User all Utiq',
                altId: 'utiq'
            }
        ]
    }

]

const EMTPY_VOLUMES = {
    total_doc: 0,
    total_mobile: 0,
    total_crm: 0,
    total_desktop: 0,
    total_desktop_first: 0,
    total_utiq_mobile: 0,
    total_utiq_home: 0,
    total_xdevice: {
        total_users: 0,
        total_users_mobile: 0,
        total_users_crm: 0,
        total_users_desktop: 0,
        total_users_desktop_first: 0,
        total_users_utiq_mobile: 0,
        total_users_utiq_home: 0,
    }
}

const VOLUMES_ORDER = {
    idbased: {
        total_desktop: 0,
        total_desktop_first: 1,
        total_crm: 2,
        total_mobile: 3,
        total_firstid: 4,
        total_utiq_mobile: 5,
        total_utiq_home: 6
    },
    xdevice: {
        total_users_desktop: 0,
        total_users_desktop_first: 1,
        total_users: 2,
        total_users_crm: 3,
        total_users_mobile: 4,
        total_users_firstid: 5,
        total_users_utiq_mobile: 6,
        total_users_utiq_home: 7,
    }
}

const THROTTLING = [
    {
        label: 'Accuracy',
        value: 'accuracy'
    },
    {
        label: 'Sampling',
        value: 'sampling'
    }
]

const RANGES = {
    recency: { min: 1, max: 30 },
    range: { min: 0, max: 20 }, //quantile
    level: { min: 0, max: 20 } //surfIntensity
}

const EXPORT_TYPES_BUILDER = [
    { value: 'media', label: 'Media', id: 'Media' },
    { value: 'second_party', label: 'Marketplace', id: 'Marketplace' },
    { value: 'audience', label: 'Audience', id: 'Audience' },
    { value: 'third_party', label: 'ThirdParty', id: 'ThirdParty' },
    { value: 'geographic', label: 'Geography', id: 'Geography' },
    { value: 'technologic', label: 'Technology', id: 'Technology' }
]

const EXPORT_TYPES_ALL = [
    ...EXPORT_TYPES_BUILDER,
    { value: 'cclone', label: 'Cclone', id: 'Cclone' },
    { value: 'transfer', label: 'Transfer', id: 'Transfer' },
    { value: 'audience_monitoring', label: 'Audience monitoring', id: 'Audience monitoring' }
]

const DATA_TYPES = ['media', 'secondParty', 'behavioral', 'demographic', 'geography', 'georadar', 'audience', 'browser', 'device', 'isp', 'os', 'dsp']
const FIRST_PARTY = ['media', 'customTaxonomies', 'data', 'custom', 'crm', 'direct', 'Georadar', 'GeoradarID']
const GEOGRAPHY = ['geography', 'georadar']
const SOCIO_DEMO = ['demographic', 'behavioral']
const TECHNOLOGY = ['browser', 'device', 'os', 'isp']
const THIRD_PARTY = [...SOCIO_DEMO, ...GEOGRAPHY, ...TECHNOLOGY]

const CRITERIA_PATH = {
    media: 'myData',
    taxonomies: 'sharing',
    demographic: 'thirdParty',
    behavioral: 'thirdParty',
    georadar: 'geography',
    audience: 'audiences',
    browser: 'technology',
    device: 'technology',
    os: 'technology',
    isp: 'technology'
}

const WAM_THIRD_PARTY_TYPES = ['Sociodemo', 'Segment', 'Cluster']

const THIRD_PARTY_TYPES = ['Sociodemo', 'Segment', 'Cluster', 'Division1', 'Division2', 'Country', 'Techno']

const MEDIA_CONVERSION_TYPE = [
    'WcmPostClickConversion',
    'WcmPostEventConversion',
    'WcmPostImpressionConversion',
    'WcmPostViewConversion',
    'WcmUntrackedConversion',
    'WcmConversion',
    'WcmAccount',
]
const MEDIA_CAMPAIGN_TYPE = ['WcmClick', 'WcmImpression']

const FIRST_PARTY_TYPE = [...MEDIA_CONVERSION_TYPE, ...MEDIA_CAMPAIGN_TYPE, 'CustomSegment', 'AppScore', 'SmartSegment', 'Audience', 'GeoradarID', 'Georadar']

const FILTERING_DEFAULT_DATES = {
    created: {
        operator: 'equal',
        from: null,
        to: new Date()
    },
    start: {
        operator: 'equal',
        from: null,
        to: new Date()
    },
    end: {
        operator: 'equal',
        from: null,
        to: null
    }
}

const FILTER_DATE_OPERATORS = [
    { label: 'equal', value: 'equal' },
    { label: 'before', value: 'before' },
    { label: 'after', value: 'after' },
    { label: 'period', value: 'period' }
]

const DEM_CONNECTION_FORM_TYPES = [
    {
        label: 'SFTP',
        value: 'sftp'
    },
    {
        label: 'FTP',
        value: 'ftp'
    },
    {
        label: 'Amazon S3',
        value: 's3'
    },
    {
        label: 'Google Cloud',
        value: 'gcloud'
    }
]

const DEM_CONNECTION_FORM_DATA = {
    id: null,
    type: 'ftp',
    label: '',
    hostname: '',
    username: '',
    password: '',
    port: '',
    region: '',
    sftpType: 'sftp_pwd',
    connector_key: ''
}

const DEM_CONFIGURATION_FORM_DATA = {
    label: '',
    task: JSON.stringify(['cb2']),
    frequency: 'hourly',
    finish_alert_emails: '',
    remote_path: '',
    file_pattern: '',
    is_file_compressed: JSON.stringify(0),
    remove_remote_files: JSON.stringify(0),
    is_weboid_crypted: JSON.stringify(0),
    delimitor: '|',
    idcrm_pattern: '',
    out_idcrm_pattern: '',
    proxy_name: ''
}

const DEM_CONFIGURATION_FORM_FREQUENCIES = [
    {
        label: 'Hourly',
        value: 'hourly'
    },
    {
        label: 'Daily',
        value: 'daily'
    },
    {
        label: 'Weekly',
        value: 'weekly'
    }
]

const DEM_CONFIGURATION_FORM_SEPARATORS = [
    {
        label: 'Comma [ , ]',
        value: ','
    },
    {
        label: 'Semicolon [ ; ]',
        value: ';'
    },
    {
        label: 'Pipe [ | ]',
        value: '|'
    }
]

const DEM_CONFIGURATION_FORM_TYPES = [
    {
        label: 'CRM',
        value: JSON.stringify(['cb2'])
    },
    {
        label: 'Proxy',
        value: JSON.stringify(['wam_proxy'])
    },
    {
        label: 'Offline Datalayer',
        value: JSON.stringify(['crm'])
    }
]

const AUDIENCES_DATATABS = [{ label: 'information' }, { label: 'transfers' }, { label: 'metrics' }]
const TRANSFER_DATATABS = [{ label: 'information' }, { label: 'audience' }]

const AUDIENCES_TABLE_PROPS = {
    config: {
        errorMsg: {
            noDataParent: {
                title: 'No audience available',
                subtitle: ''
            },
            noDataChild: {
                title: 'No transfer available',
                subtitle: ''
            }
        },
        mainDataRow: [
            {
                key: 'expandIcon',
                fullName: '',
                cellWidth: 'extra-small',
                textAlign: 'center',
                sort: false,
                component: ExpandIcon
            },
            {
                key: 'id',
                fullName: 'ID',
                textAlign: 'left',
                sort: true,
                sortOrder: 'desc',
                cellClass: 'cell-id'
            },
            {
                key: 'sharedIcon',
                fullName: '',
                cellWidth: 'extra-small',
                textAlign: 'center',
                sort: false,
                component: SharedIcon
            },
            {
                key: 'label',
                fullName: 'Label',
                cellWidth: 'large',
                textAlign: 'left',
                sort: true,
                sortOrder: 'asc',
                component: AudienceLabel,
                cellClass: 'cell-label'
            },
            {
                key: 'createdAt',
                fullName: 'Added On',
                textAlign: 'center',
                sort: true,
                sortOrder: 'desc',
                cellClass: 'cell-date'
            },
            {
                key: 'endDate',
                fullName: 'End Date',
                textAlign: 'center',
                sort: true,
                sortOrder: 'desc',
                cellClass: 'cell-date'
            },
            {
                key: 'bootstrap',
                fullName: 'Bootstrap',
                textAlign: 'center',
                sort: false,
                cellClass: 'cell-bootstrap'
            },
            {
                key: 'volume',
                fullName: 'Volume',
                textAlign: 'right',
                component: CellVolume,
                sort: false,
                cellClass: 'cell-volume'
            }
            // {
            //     key: 'actions',
            //     fullName: '',
            //     cellWidth: 'extra-small',
            //     textAlign: 'center',
            //     component: CellAudienceAction,
            //     sort: false
            // }
        ],
        childDataRow: [
            {
                key: 'id',
                fullName: 'ID',
                cellWidth: 'small',
                textAlign: 'left',
                sort: false
            },
            {
                key: 'label',
                fullName: 'Label',
                cellWidth: 'normal',
                textAlign: 'left',
                sort: false
            },
            {
                key: 'partner',
                fullName: 'Partner',
                cellWidth: 'normal',
                textAlign: 'left',
                sort: false
            },
            {
                key: 'partnerConfiguration',
                fullName: 'Partner Configuration',
                cellWidth: 'normal',
                textAlign: 'left',
                sort: false
            },
            {
                key: 'endDate',
                fullName: 'End Date',
                cellWidth: 'normal',
                textAlign: 'left',
                sort: false
            },
            {
                key: 'bootstrap',
                fullName: 'Bootstrap',
                cellWidth: 'normal',
                textAlign: 'center',
                sort: false
            }
            // {
            //     key: 'actions',
            //     fullName: '',
            //     cellWidth: 'extra-small',
            //     textAlign: 'center',
            //     component: CellTransferAction,
            //     sort: false
            // }
        ]
    },
    pagination: {
        currentPage: 1,
        rowPerPage: 10
    },
    sorting: {
        key: 'id',
        order: 'desc'
    }
}

const AUDIENCES_SEARCH_PROPS = [
    { label: '---', value: '' },
    { label: 'Label', value: 'label' },
    { label: 'Id', value: 'id' },
    { label: 'Tag', value: 'tag' }
]

const AUDIENCES_FILTERS_PROPS = [
    {
        icon: { name: 'filter', size: 'small' },
        label: 'Status',
        key: 'status',
        targets: [
            {
                label: 'All status',
                value: ''
            },
            {
                label: 'Active',
                value: 'active'
            },
            {
                label: 'Inactive',
                value: 'inactive'
            }
        ],
        type: 'singleSelect'
    },
    {
        icon: { name: 'bootstrap', size: 'small' },
        label: 'Bootstrap',
        key: 'bootstrap',
        targets: [
            {
                label: 'All Bootstraps',
                value: ''
            },
            {
                label: 'Attributed',
                value: 'attributed'
            },
            {
                label: 'Failed',
                value: 'failed'
            },
            {
                label: 'Processing',
                value: 'processing'
            },
            {
                label: 'Attribute',
                value: 'attribute'
            },
            {
                label: 'None',
                value: 'none'
            }
        ],
        type: 'singleSelect'
    },
    {
        icon: { name: 'filter', size: 'small' },
        label: 'Type',
        key: 'type',
        targets: [
            {
                label: 'All Type',
                value: ''
            },
            {
                label: 'Cclone',
                value: 'cclones'
            },
            {
                label: 'Georadar',
                value: 'georadar'
            }
        ],
        type: 'singleSelect'
    },
    {
        icon: { name: 'filter', size: 'small' },
        label: 'Volume',
        key: 'type_volume',
        targets: [
            {
                label: 'ID Based',
                value: ''
            },
            {
                label: 'Cross device',
                value: 'crossdevice'
            }
        ],
        type: 'singleSelect'
    },
    {
        icon: { name: 'share', size: 'small' },
        label: 'Shared',
        key: 'shared',
        targets: [
            {
                label: '---',
                value: ''
            },
            {
                label: 'Yes',
                value: 'yes'
            },
            {
                label: 'No',
                value: 'no'
            }
        ],
        type: 'singleSelect'
    }
]

const JOBS_DATATABS = [
    {
        label: 'file',
        iconName: 'audience'
    },
    {
        label: 'configuration',
        iconName: 'trending-up'
    }
]

const JOBS_TABLE_PROPS = {
    config: {
        errorMsg: {
            noDataParent: {
                title: 'No job available',
                subtitle: ''
            }
        },
        mainDataRow: [
            {
                key: 'id',
                fullName: 'ID',
                cellWidth: 'small',
                textAlign: 'left',
                sort: true,
                sortOrder: 'desc'
            },
            {
                key: 'label',
                fullName: 'Label',
                cellWidth: 'normal',
                textAlign: 'left',
                sort: true,
                sortOrder: 'asc',
                component: Status
            },
            {
                key: 'created_at',
                fullName: 'Start date',
                cellWidth: 'normal',
                textAlign: 'center',
                sort: true,
                sortOrder: 'desc'
            },
            {
                key: 'updated_at',
                fullName: 'Update Date',
                cellWidth: 'normal',
                textAlign: 'center',
                sort: true,
                sortOrder: 'desc'
            },
            {
                key: 'displayType',
                fullName: 'Type',
                cellWidth: 'normal',
                textAlign: 'left',
                sort: true,
                sortOrder: 'asc'
            }
        ]
    },
    pagination: {
        currentPage: 1,
        rowPerPage: 10
    },
    sorting: {
        key: 'id',
        order: 'desc'
    }
}

const JOBS_FILTERS_PROPS = [
    {
        icon: { name: 'filter', size: 'small' },
        // hideIcon: false,
        label: 'Status',
        key: 'status',
        targets: [
            {
                label: 'All status',
                value: ''
            },
            {
                label: 'Failed',
                value: 'failed'
            },
            {
                label: 'Finished',
                value: 'finished'
            },
            {
                label: 'Pending',
                value: 'pending'
            },
            {
                label: 'Processing',
                value: 'processing'
            }
        ],
        type: 'singleSelect'
    },
    {
        icon: { name: 'data', size: 'small' },
        label: 'Type',
        key: 'type',
        targets: [
            {
                label: 'All types',
                value: ''
            },
            {
                label: 'CRM',
                value: 'cb2'
            },
            {
                label: 'Proxy',
                value: 'wam_proxy'
            },
            {
                label: 'Offline Datalayer',
                value: 'crm'
            }
        ],
        type: 'singleSelect'
    }
]

const JOBS_SEARCH_PROPS = [
    { label: '---', value: '' },
    { label: 'Label', value: 'label' },
    { label: 'Id', value: 'id' }
]

const CCLONE_DATATABS = [
    {
        label: 'information',
        iconName: 'audience'
    },
    {
        label: 'parameters',
        iconName: 'trending-up'
    }
]

const CCLONE_TABLE_PROPS = {
    config: {
        errorMsg: {
            noDataParent: {
                title: 'No cclone available',
                subtitle: ''
            }
        },
        mainDataRow: [
            {
                key: 'id',
                fullName: 'ID',
                cellWidth: 'small',
                textAlign: 'left',
                sort: true,
                sortOrder: 'desc'
            },
            {
                key: 'label',
                fullName: 'Label',
                cellWidth: 'normal',
                textAlign: 'left',
                sort: true,
                sortOrder: 'asc',
                component: Status
            },
            {
                key: 'created_at',
                fullName: 'Created At',
                cellWidth: 'normal',
                textAlign: 'center',
                sort: true,
                sortOrder: 'desc'
            },
            {
                key: 'start_date',
                fullName: 'Activation',
                cellWidth: 'normal',
                textAlign: 'left',
                sort: true,
                sortOrder: 'desc'
            },
            {
                key: 'end_date',
                fullName: 'End Date',
                cellWidth: 'normal',
                textAlign: 'center',
                sort: true,
                sortOrder: 'desc'
            },
            {
                key: 'positive_events',
                fullName: 'Positive',
                cellWidth: 'normal',
                textAlign: 'left',
                sort: false,
                component: TableVolumes
            },
            {
                key: 'negative_events',
                fullName: 'Negative',
                cellWidth: 'normal',
                textAlign: 'left',
                sort: false,
                component: TableVolumes
            }
        ]
    },
    pagination: {
        rowPerPage: 10,
        currentPage: 1
    },
    sorting: {
        key: 'id',
        order: 'desc'
    }
}

const CCLONE_FILTERS_PROPS = [
    {
        icon: { name: 'filter', size: 'small' },
        // hideIcon: false,
        label: 'Status',
        key: 'status',
        targets: [
            {
                label: 'All status',
                value: ''
            },
            {
                label: 'Available',
                value: 'available'
            },
            {
                label: 'Failed',
                value: 'failed'
            },
            {
                label: 'Waiting',
                value: 'waiting'
            },
            {
                label: 'Running',
                value: 'running'
            }
        ],
        type: 'singleSelect'
    }
]

const CCLONE_SEARCH_PROPS = [
    { label: '---', value: '' },
    { label: 'Label', value: 'label' },
    { label: 'Id', value: 'id' }
]

const DSP_CONFIGURATIONS_TABLE_PROPS = {
    config: {
        errorMsg: {
            noDataParent: {
                title: 'No configuration available',
                subtitle: ''
            }
        },
        mainDataRow: [
            {
                key: 'partnerLabel',
                fullName: 'Partner',
                cellWidth: 'normal',
                textAlign: 'left',
                sort: true,
                sortOrder: 'desc'
            },
            {
                key: 'dsp_client_id',
                fullName: 'Identifier',
                cellWidth: 'normal',
                textAlign: 'left',
                sort: true,
                sortOrder: 'desc'
            },
            {
                key: 'label',
                fullName: 'Label',
                cellWidth: 'large',
                textAlign: 'left',
                sort: true,
                sortOrder: 'desc'
            },
            {
                key: 'actions',
                fullName: '',
                cellWidth: 'extra-small',
                textAlign: 'center',
                component: CellConfigAction,
                sort: false
            }
        ]
    },
    pagination: {
        rowPerPage: 10,
        currentPage: 1
    },
    sorting: {
        key: 'partner',
        order: 'asc'
    }
}
const SETTINGS_CONFIGURATIONS_TABLE_PROPS = {
    config: {
        errorMsg: {
            noDataParent: {
                title: 'No namespaces available',
                subtitle: ''
            }
        },
        mainDataRow: [
            {
                key: 'id',
                fullName: 'id',
                cellWidth: 'normal',
                textAlign: 'left',
                sort: true,
                sortOrder: 'desc'
            },
            {
                key: 'type',
                fullName: 'type',
                cellWidth: 'normal',
                textAlign: 'left',
                sort: true,
                sortOrder: 'desc'
            },
            {
                key: 'label',
                fullName: 'Label',
                cellWidth: 'large',
                textAlign: 'left',
                sort: true,
                sortOrder: 'desc'
            },
            {
                key: 'actions',
                fullName: '',
                cellWidth: 'extra-small',
                textAlign: 'center',
                component: CellNamespaceAction,
                sort: false
            }
        ]
    },
    pagination: {
        rowPerPage: 10,
        currentPage: 1
    },
    sorting: {
        key: 'id',
        order: 'desc'
    }
}

const SETTINGS_AUDIENCE_SHARING_TABLE_PROPS = {
    config: {
        errorMsg: {
            noDataParent: {
                title: 'No sharing available',
                subtitle: ''
            }
        },
        mainDataRow: [
            {
                key: 'id',
                fullName: 'id',
                cellWidth: 'normal',
                textAlign: 'left',
                sort: true,
                sortOrder: 'desc'
            },
            {
                key: 'label',
                fullName: 'account',
                cellWidth: 'large',
                textAlign: 'left',
                sort: true,
                sortOrder: 'desc'
            },
            {
                key: 'audience_sharing',
                fullName: 'Share',
                cellWidth: 'extra-small',
                textAlign: 'center',
                component: CellCheck,
                sort: true,
                sortOrder: 'asc'
            }
        ]
    },
    pagination: {
        rowPerPage: 10,
        currentPage: 1
    },
    sorting: {
        key: 'audience_sharing',
        order: 'asc'
    }
}

const SETTINGS_TAXONOMY_SHARING_TABLE_PROPS = {
    config: {
        errorMsg: {
            noDataParent: {
                title: 'No sharing available',
                subtitle: ''
            }
        },
        mainDataRow: [
            {
                key: 'id',
                fullName: 'id',
                cellWidth: 'normal',
                textAlign: 'left',
                sort: true,
                sortOrder: 'desc'
            },
            {
                key: 'label',
                fullName: 'account',
                cellWidth: 'large',
                textAlign: 'left',
                sort: true,
                sortOrder: 'desc'
            },
            {
                key: 'wam_custom_taxonomy_sharing',
                fullName: 'Share',
                cellWidth: 'extra-small',
                textAlign: 'center',
                component: CellCheck,
                sort: true,
                sortOrder: 'asc'
            }
        ]
    },
    pagination: {
        rowPerPage: 10,
        currentPage: 1
    },
    sorting: {
        key: 'wam_custom_taxonomy_sharing',
        order: 'asc'
    }
}

const SHARING_SEARCH_PROPS = [
    { label: '---', value: '' },
    { label: 'Account', value: 'label' },
    { label: 'Id', value: 'id' }
]

const API_SOCIODEMO_SETTINGS = {
    technology: 'technologic_activated',
    demographic: 'bigsea_sociodemo',
    behavioral: 'bigsea_behavioral',
    geography: 'geographic_activated'
}

const API_GENERAL_SETTINGS = {
    demographicBreakdown: 'demographic_breakdown_activated',
    frequency: 'frequency_activated',
    quantile: 'quantile_activated',
    surfintensity: 'surf_intensity_activated',
    accuracy: 'throttle_level',
    bootstrapPush: 'stock_delivery_activated',
    catalog: 'account_type',
    dashboardAndAlerts: 'dashboard_alerts_activated',
    firstPartyCookie: 'first_party_cookie_volume_activated',
    providerFirstIdActivated: 'provider_firstid_activated',
    providerUtiqActivated: 'provider_utiq_activated',
}

const SETTINGS = ['general', 'sociodemo', 'datamining', 'dataMining', 'wamFactory']

const PIXEL_URL_RANDOM_PARAM = 'd.r=~RANDOM~'

const ITEMS_PER_PAGE_LIST = [10, 25, 50, 100]

const DSP_KEY_LABELS = {
    adform: 'adform',
    adobe: 'tubemogul',
    adventori: 'adventori',
    appNexus: 'appnexus', //XandR
    criteov2: 'criteov2',
    datahub: 'datahub',
    debug: 'debug',
    facebook: 'facebook',
    freeWheel: 'freewheel',
    genericDsp: 'generic',
    googleCloudStorage: 'gcs',
    googleDdp: 'googledbm',
    googleDmp: 'googledmp',
    mailRu: 'mailru',
    mediamath: 'mediamath',
    nielsen: 'nielsen',
    pubmatic: 'pubmatic',
    radiumOne: 'radiumone',
    rubicon: 'rubicon',
    smartAdServer: 'smartadserver',
    snapchat: 'snapchat',
    theTradeDesk: 'thetradedesk',
    tiktok: 'tiktok',
    videology: 'videology',
    yahoo: 'yahoo',
    yandex: 'yandex',
    zbo: 'zebestof',
    gam: 'gam',
    utiqEquativ: 'utiq_equativ',
    utiqAdform: 'utiq_adform'
}

const SEGMENT_FORM_DATATABS = [{ label: 'information' }, { label: 'frequency' }]

const GEORADAR_DATATABS = [{ label: 'new' }, { label: 'existing' }]

const ACTIVITY_SOURCES = {
    big: {
        sourceField: 'big',
        alias: 'BigSea',
        source: 'Weborama Taxonomies',
        hint: 'Weborama taxonomies include all the allocations related to third party taxonomies'
    },
    dlv: {
        sourceField: 'dlv',
        alias: 'Deliver',
        source: 'Audience Bootstrap',
        hint: 'Audience Bootstrap includes all the allocations related to an audience bootstrap'
    },
    cdm: {
        sourceField: 'cdm',
        alias: 'CSDatamining',
        source: 'Data Service',
        hint: 'Data Service represent all the allocations related to direct allocation from the Weborama data science team'
    },
    cpt: {
        sourceField: 'cpt',
        alias: 'CSPunctual',
        source: 'Data Entry Manager',
        hint: 'Data Entry Manager includes all the allocations related to customer file import (CRM, Proxy, Offline datalayer)'
    },
    crb: {
        sourceField: 'crb',
        alias: 'CSRuleBootstrap',
        source: 'Custom Segment Bootstrap',
        hint: 'Custom Segment Bootstrap includes all the allocations related to the bootstrap of custom segment rules'
    },
    crt: {
        sourceField: 'crt',
        alias: 'CSRealtime',
        source: 'Generic Collect',
        hint: 'Generic Collect includes all the allocations linked to a hit on a basic WAM pixe'
    },
    crg: {
        sourceField: 'crg',
        alias: 'CSRealtimeGCP',
        source: 'Generic Collect GCP',
        hint: ''
    },
    cwf: {
        sourceField: 'cwf',
        alias: 'CSRealtimeWAMFactory',
        source: 'Collect',
        hint: 'Advanced collect includes all the allocations related to a hit on a collect with datalayer'
    },
    cre: {
        sourceField: 'cre',
        alias: 'CSRemoval',
        source: 'Custom Segment Removal',
        hint: ''
    },
    scp: {
        sourceField: 'scp',
        alias: 'SecondParty',
        source: 'Marketplace',
        hint: 'Marketplace includes all the allocations related to the Marketplace taxonomies and or clusters'
    },
    sse: {
        sourceField: 'sse',
        alias: 'SmartSegment',
        source: 'Custom Segment Frequency',
        hint: 'Custom Segment Frequency includes all the allocations related to the Frequency used on custom segment'
    },
    wcm: {
        sourceField: 'wcm',
        alias: 'WCM',
        source: 'WCM',
        hint: 'WCM includes all the allocations related to WCM data'
    },
    all: {
        sourceField: 'all',
        alias: 'N/A',
        source: 'Total of all sources for a metric (this is a meta source)',
        hint: ''
    }
}

const VOLUME_CHART_COLORS = {
    total_desktop_first: '#189CFB',
    total_crm: '#ED7D61',
    total_doc: 'red',
    total_mobile: '#BD3ADE',
    total_desktop: '#779CE6',
    total_firstid: 'linear-gradient(180deg, #F8A430 0%, #FCCD32 100%)',
    total_utiq_home: 'rgba(240, 25, 68, 1)',
    total_utiq_mobile: 'rgba(89, 11, 255, 1)',

    total_users_desktop_first: 'rgba(208, 136, 198, 1)',
    total_users_crm: '#ED7D61',
    total_users: '#333',
    total_users_mobile: '#8C65D3',
    total_users_desktop: 'rgba(209, 92, 143, 1)',
    total_users_firstid: 'linear-gradient(180deg, #F8A430 0%, #FCCD32 100%)',
    total_users_utiq_home: 'rgba(240, 25, 68, 1)',
    total_users_utiq_mobile: 'rgba(89, 11, 255, 1)',
}

export {
    API_GENERAL_SETTINGS,
    API_SOCIODEMO_SETTINGS,
    AUDIENCES_DATATABS,
    TRANSFER_DATATABS,
    AUDIENCES_FILTERS_PROPS,
    AUDIENCES_SEARCH_PROPS,
    AUDIENCES_TABLE_PROPS,
    BUILDER_CRITERIA_LIMITS,
    CCLONE_DATATABS,
    CCLONE_FILTERS_PROPS,
    CCLONE_SEARCH_PROPS,
    CCLONE_TABLE_PROPS,
    CRITERIA_PATH,
    DATA_TYPES,
    DEM_CONFIGURATION_FORM_FREQUENCIES,
    DEM_CONFIGURATION_FORM_DATA,
    DEM_CONFIGURATION_FORM_SEPARATORS,
    DEM_CONFIGURATION_FORM_TYPES,
    DEM_CONNECTION_FORM_DATA,
    DEM_CONNECTION_FORM_TYPES,
    DSP_CONFIGURATIONS_TABLE_PROPS,
    DSP_KEY_LABELS,
    SETTINGS_CONFIGURATIONS_TABLE_PROPS,
    SETTINGS_AUDIENCE_SHARING_TABLE_PROPS,
    SETTINGS_TAXONOMY_SHARING_TABLE_PROPS,
    SHARING_SEARCH_PROPS,
    EMTPY_VOLUMES,
    EXPORT_TYPES_ALL,
    EXPORT_TYPES_BUILDER,
    FILTER_DATE_OPERATORS,
    FILTERING_DEFAULT_DATES,
    FIRST_PARTY,
    FIRST_PARTY_TYPE,
    GEOGRAPHY,
    GEORADAR_DATATABS,
    ITEMS_PER_PAGE_LIST,
    JOBS_DATATABS,
    JOBS_FILTERS_PROPS,
    JOBS_SEARCH_PROPS,
    JOBS_TABLE_PROPS,
    MEDIA_CAMPAIGN_TYPE,
    MEDIA_CATEGORIES,
    MEDIA_CONVERSION_TYPE,
    PIXEL_URL_RANDOM_PARAM,
    RANGES,
    SEGMENT_FORM_DATATABS,
    SETTINGS,
    SOCIO_DEMO,
    SOCIO_DEMO_CATEGORIES,
    TECHNO_CATEGORIES,
    TECHNOLOGY,
    THIRD_PARTY,
    THIRD_PARTY_TYPES,
    THROTTLING,
    VOLUMES,
    UTIQ_VOLUMES,
    VOLUMES_ORDER,
    VOLUME_CHART_COLORS,
    WAM_THIRD_PARTY_TYPES,
    ACTIVITY_SOURCES
}
